module.exports = __webpack_public_path__ + "fonts/ebac-icons.6fc67fb.eot";